import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListLuasAset } from "@/services/getData"

export default function MasterLuasAsetPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listLuasAset"],
    queryFn: getListLuasAset,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
